import { DebugLoggingType } from '../models/debug-config.model';

export const DEFAULT_LOGGING_TYPE: DebugLoggingType = 'NONE';
